import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { AppContext } from "../contextApp";

const PaymentNav = () => {
  const { studentData } = useContext(AppContext);
  const [active, setActive] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/Payment/PaymentDetail")) {
      setActive(0);
    } else if (location.pathname.startsWith("/Payment/PaymentAdditional")) {
      setActive(1);
    } else if (location.pathname.startsWith("/Payment/PaymentHistory")) {
      setActive(2);
    }
  }, [location.pathname]);

  return (
    <nav
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '10px 24px', backgroundColor: '#1f2937',
        borderBottom: '1px solid #374151', flexWrap: 'wrap', gap: '10px',
      }}
    >
      {/* Student info */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{
          width: '32px', height: '32px', borderRadius: '50%',
          backgroundColor: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <i className="fa-solid fa-user-graduate" style={{ fontSize: '13px', color: '#9ca3af' }}></i>
        </div>
        <div>
          <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#f9fafb', lineHeight: 1.2 }}>
            {studentData.name}
          </div>
          {studentData.career_name && (
            <div style={{ fontSize: '0.7rem', color: '#9ca3af', marginTop: '2px' }}>
              {studentData.career_name}
            </div>
          )}
        </div>
      </div>

      {/* Tabs */}
      {studentData.name !== "" && (
        <div style={{
          display: 'flex', backgroundColor: '#111827',
          borderRadius: '7px', padding: '3px', gap: '2px',
        }}>
          {[
            { label: 'Cuatrimestre', idx: 0, to: `PaymentDetail/${studentData.student_id}` },
            { label: 'Adicional',    idx: 1, to: `PaymentAdditional/${studentData.student_id}` },
            { label: 'Historial',    idx: 2, to: `PaymentHistory/${studentData.student_id}` },
          ].map(({ label, idx, to }) => (
            <Link
              key={idx}
              to={to}
              style={{
                padding: '6px 18px', borderRadius: '5px', fontSize: '0.75rem',
                fontWeight: 600, textDecoration: 'none', transition: 'all 0.15s',
                backgroundColor: active === idx ? '#dc2626' : 'transparent',
                color: active === idx ? '#fff' : '#9ca3af',
              }}
            >
              {label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default PaymentNav;
